import { Phone, Calendar, Truck } from "lucide-react";

const STEPS = [
  {
    n: "01",
    icon: Phone,
    title: "Contactați-ne",
    desc: "Sunați la Fetești 0766 693 105 sau Slobozia 0722 569 492, între orele 08:00 și 17:00. Discutați direct cu echipa noastră.",
  },
  {
    n: "02",
    icon: Calendar,
    title: "Detalii & Ofertă",
    desc: "Stabilim împreună tipul de beton, cantitatea exactă, prețul și data turnării.",
  },
  {
    n: "03",
    icon: Truck,
    title: "Programare 48h",
    desc: "Comenzile se fac cu minim 48 de ore înainte de turnare. Livrăm la timp, direct pe șantier.",
  },
];

export default function Process() {
  return (
    <section id="proces" data-testid="process-section" className="py-20 sm:py-32 bg-[#0A0A0A] text-white relative overflow-hidden">
      <div aria-hidden className="absolute inset-0 grain opacity-50" />
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 relative">
        <div className="max-w-3xl">
          <div className="font-mono-tech text-[11px] tracking-[0.25em] uppercase text-[#F59E0B] mb-6">
            · 03 / PROCESUL DE COMANDĂ
          </div>
          <h2 className="font-display text-5xl sm:text-6xl lg:text-7xl uppercase leading-[0.9] tracking-tight">
            Cum<br />
            <span className="text-[#F59E0B]">Comandați</span>
          </h2>
          <p className="mt-6 text-base sm:text-lg text-neutral-300 leading-relaxed max-w-xl">
            Proces simplu, transparent și fără surprize. Comanda dumneavoastră este
            confirmată telefonic.
          </p>
        </div>

        <div className="mt-16 grid grid-cols-1 md:grid-cols-3 gap-px bg-white/10 border border-white/10">
          {STEPS.map(({ n, icon: Icon, title, desc }) => (
            <div
              key={n}
              data-testid={`process-step-${n}`}
              className="bg-[#0A0A0A] p-8 sm:p-10 flex flex-col gap-6 hover:bg-[#141414] transition-colors duration-300"
            >
              <div className="flex items-center justify-between">
                <span className="font-display text-6xl sm:text-7xl text-[#F59E0B] leading-none">{n}</span>
                <Icon className="w-7 h-7 text-white/60" strokeWidth={1.5} />
              </div>
              <div>
                <div className="font-display text-2xl sm:text-3xl uppercase tracking-tight">{title}</div>
                <p className="mt-3 text-sm text-neutral-400 leading-relaxed">{desc}</p>
              </div>
            </div>
          ))}
        </div>

        <div className="mt-12 flex flex-wrap items-center gap-3">
          <a
            href="tel:0766693105"
            data-testid="process-call-fetesti"
            className="btn-amber rounded-sm inline-flex items-center gap-2 px-5 py-3.5 text-sm font-bold uppercase tracking-wider"
          >
            <Phone className="w-4 h-4" strokeWidth={2.5} />
            <span className="text-[10px] tracking-[0.2em] opacity-70">FETEȘTI</span>
            <span>· 0766 693 105</span>
          </a>
          <a
            href="tel:0722569492"
            data-testid="process-call-slobozia"
            className="rounded-sm inline-flex items-center gap-2 px-5 py-3.5 text-sm font-bold uppercase tracking-wider bg-white text-[#0A0A0A] hover:bg-neutral-200 transition-colors"
          >
            <Phone className="w-4 h-4 text-[#F59E0B]" strokeWidth={2.5} />
            <span className="text-[10px] tracking-[0.2em] opacity-70">SLOBOZIA</span>
            <span>· 0722 569 492</span>
          </a>
          <span className="font-mono-tech text-xs tracking-[0.2em] uppercase text-neutral-400">
            Luni — Vineri · 08:00 - 17:00
          </span>
        </div>
      </div>
    </section>
  );
}
